<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :title="'신고내역'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex: 1; margin-top: 20px; padding: 0 12px;">
            <div>
                <div style="display: flex; align-items: center; gap: 4px; margin-bottom: 5px; font-size: 12px; font-weight: 500; color: #606060;">
                    <div style="line-height: 20px;">{{ transDate(historyDetail.insert_date) }}</div>
                    <div style="width: 2px; height: 2px; background-color: #606060; border-radius: 50%;"></div>
                    <div style="line-height: 20px;">{{ transTitle(historyDetail.refer_type) }}</div>
                </div>
                <div v-if="historyDetail.refer_type == REPORT_TYPE_IDX.SOCCERHOW_ANYONE || historyDetail.refer_type == REPORT_TYPE_IDX.SOCCERHOW_COACH" style="font-weight: 500; font-size: 14px; line-height: 24px;"><span style="font-weight: 700;">{{ historyDetail.target_nic_name }}</span>님의 게시물을 신고했습니다.</div>
                <div v-else-if="historyDetail.refer_type == REPORT_TYPE_IDX.SCHEDULE" style="font-weight: 500; font-size: 14px; line-height: 24px;"><span style="font-weight: 700;">{{ historyDetail.report_title }}</span>스케줄을 신고했습니다.</div>
                <div v-if="historyDetail.refer_type == REPORT_TYPE_IDX.JOIN" style="font-weight: 500; font-size: 14px; line-height: 24px;"><span style="font-weight: 700;">{{ historyDetail.report_title }}</span>멤버톡을 신고했습니다.</div>
            </div>
            <div style="margin-top: 12px; font-size: 12px; color: #606060; line-height: 20px; font-weight: 500;">
                {{ $GlobalStore.loginInfo().nic_name }}님, 문제를 신고해주셔서 감사합니다. 사커하우는 안전하고 건전한 커뮤니티 환경을 만들기 위해 신고 내역을 검토하여 계정 비활성화, 강제 삭제, 이용 정지 등의 조치를 진행할 예정입니다. 커뮤니티 환경에 피해를 주는 행동이 아닐 경우 1차 권고, 내용 삭제 등의 소극적인 조치가 이루어질 수 있습니다.
            </div>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from "@/components/common/MercenaryHeader";
import { REPORT_TYPE_IDX } from "@/Constants"

export default {
    name: 'ReportHistoryDetail',
    components: { MercenaryHeader },
    props: {
        historyDetail: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            REPORT_TYPE_IDX: REPORT_TYPE_IDX,
        }
    },
    methods: {
        transDate(date) {
            let transDate = date.split(' ')
            transDate = transDate[0].split('-').splice(1, 2)
            return `${transDate[0]}월 ${transDate[1]}일`
        },
        transTitle(refer_type) {
            switch (parseInt(refer_type)) {
                case REPORT_TYPE_IDX.SCHEDULE:
                    return '스케줄';
                case REPORT_TYPE_IDX.JOIN:
                    return '멤버톡'
                case REPORT_TYPE_IDX.SOCCERHOW_ANYONE:
                case REPORT_TYPE_IDX.SOCCERHOW_COACH:
                    return '하우'
                case REPORT_TYPE_IDX.JOIN_COMMUNITY:
                    return '커뮤니티'
                case REPORT_TYPE_IDX.PROFILE:
                    return '프로필'
            }
            // return refer_type
        }
    }
}
</script>

<style scoped>
.circle {
    width: 5px;
    height: 5px;
    background-color: #210f03;
    border-radius: 50%;
}
</style>